<section  class="current-training" fxLayout="column" fxLayoutAlign="center center">
  <mat-progress-spinner mode="determinate" [value]="progress"></mat-progress-spinner>
  <h1> {{ progress }}%</h1>
  <p>Keep going. You can do it!</p>
  <button mat-raised-button color="accent" (click)="onStop()">Stop</button>
</section>